export default "__VITE_ASSET__D5Is2dUZ__"